import type { BigNumber } from '@ethersproject/bignumber';
import Info from '@ui/components/Info';
import type { Token } from '@ui/components/TokenIcon';
import { TokenIcon } from '@ui/components/TokenIcon';
import { formatTokenAmount } from '@ui/utils/format';
import React from 'react';

type HarvestAllTokenInfoProps = {
  title: string;
  token: Token;
  tokenRewards?: BigNumber;
  usdRewards?: BigNumber;
  tokenDecimals?: number;
};

function HarvestAllTokenInfo({
  token,
  title,
  usdRewards,
  tokenRewards,
  tokenDecimals,
}: HarvestAllTokenInfoProps) {
  return (
    <Info
      title={title}
      convertedValue={
        usdRewards ? formatTokenAmount(usdRewards, 2) + ' USD' : undefined
      }
      value={formatTokenAmount(tokenRewards, 4, tokenDecimals ?? 18)}
      icon={(props) => <TokenIcon token={token} {...props} />}
    />
  );
}

export default HarvestAllTokenInfo;
